import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  paper: {
    width: '100%',
    padding: [theme.spacing(3), theme.spacing(4)],
    borderBottom: [1, 'solid', theme.palette.colors.border],
    [theme.breakpoints.up('mobile')]: {
      borderBottom: 'none',
      borderRight: [1, 'solid', theme.palette.colors.border],
      width: '25%',
      minWidth: 295,
    },
  },
  label: {
    fontWeight: 600,
    padding: [theme.spacing(1), theme.spacing(1), theme.spacing(1), 0],
    overflow: 'hidden',
    position: 'relative',
    display: 'inline-block',
    zIndex: 0,
    '&::before': {
      content: "''",
      position: 'absolute',
      left: '50%',
      bottom: 5,
      width: `calc(100% - ${theme.spacing(1)}px)`,
      height: 10,
      transform: ['skew(-12deg)', 'translateX(-50%)'],
      background: theme.palette.colors.teal,
      zIndex: -1,
      opacity: '50%',
    },
  },
  bold: {
    fontWeight: 800,
  },
}));



// WEBPACK FOOTER //
// ./src/components/QuizPage/components/SummaryPage/components/MortgagePayment/useStyles.js